import { useI18nContext } from '@ecg-marktplaats/js-react-i18n';
import React, { useContext, useEffect, useState } from 'react';

import { TListingClient } from 'types/TListing';
import EnvironmentContext from '../../../../contexts/EnvironmentContext';
import useCesSurvey from '../../../../hooks/useCesSurvey';
import { storeToRecentlyViewedVips } from '../../../../utils/storeToRecentlyViewedVips';
import storeVipViewCount from '../../../../utils/storeVipViewCount';
import Gallery from '../Gallery/Gallery';
import Classes from './Listing.scss';

type TListingProps = {
  listing: TListingClient;
  withTour?: boolean;
};

let Tour;
const LOCAL_STORAGE_KEY_TOUR_SEEN = 'CarsTourSeen';

const Listing = ({ listing, withTour }: TListingProps) => {
  const { t } = useI18nContext();
  const {
    userDetails: { isAdOwner = false } = {},
    experiments: { isCarsVipTourEnabled },
  } = useContext(EnvironmentContext);
  const [tourLoaded, setTourLoaded] = useState(false);
  const { itemId, isSaved, isSavingEnabled, gallery, title, traits = [], isCarAd } = listing;
  const showMicroTipText = traits.includes('MICROTIP');
  const showUrgencyText = traits.includes('URGENCY');
  const { loadSurvey } = useCesSurvey(isCarAd);

  useEffect(() => {
    window.addEventListener('asqSent', loadSurvey, false);
    return () => window.removeEventListener('asqSent', loadSurvey, false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    storeToRecentlyViewedVips(t, listing);
    storeVipViewCount(listing.isCarAd);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (!localStorage) {
      return;
    }
    const storageItemTour = localStorage.getItem(LOCAL_STORAGE_KEY_TOUR_SEEN);

    if (isCarsVipTourEnabled && withTour && !storageItemTour) {
      (async () => {
        try {
          Tour = (await import(/* webpackChunkName: "tour" */ './Tour/Tour')).default;
          setTourLoaded(true);
          localStorage.setItem(LOCAL_STORAGE_KEY_TOUR_SEEN, JSON.stringify(true));
        } catch {}
      })();
    }
  }, [isCarsVipTourEnabled, withTour]);

  return (
    <div className={Classes.root}>
      <Gallery
        gallery={gallery}
        title={title}
        itemId={itemId}
        showMicroTipText={showMicroTipText}
        showUrgencyText={showUrgencyText}
        withFavoriteButton={isSavingEnabled && !isAdOwner}
        isSaved={isSaved}
        favoritedCount={listing.stats.favoritedCount}
      />
      {tourLoaded && <Tour />}
    </div>
  );
};

export default Listing;
